import React, { createContext, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { useEventResolver } from './utils/useEventResolver';

const EventContext = createContext(null);

export const EventProvider = ({ children }) => {
  const { eventId: slug } = useParams();
  const { realEventId, loading, error } = useEventResolver(slug);

  if (loading) return null;

  if (error) {
     return <div className="text-center p-10 text-red-500">Error resolving event.</div>;
  }

  return (
    <EventContext.Provider value={{ realEventId, slug }}>
      {children}
    </EventContext.Provider>
  );
};

export const useEventId = () => {
    return useContext(EventContext);
};
